export default __webpack_public_path__ + "static/media/enamad-copy.7135db59.png";